// Core functionality of redux state is tied to these methods and param reassignment.
// Since Redux is basically legacy code at this point we are grandfathering in these files. The rule will be enforced for any new code committed.
/* eslint-disable no-param-reassign */
import * as searchParameterAvailability from 'app/support/searchParameterAvailability';

export default class SearchParameterAvailabilityInteraction {
  constructor(galleryState) {
    this.searchProfile = galleryState.searchProfile;
  }

  applyStateUpdates(stateUpdates) {
    stateUpdates.availableSearchParameters =
      searchParameterAvailability.availableSearchParametersForSearch(
        stateUpdates.searchParameters,
        this.searchProfile
      );
    const enforcedSearchParameters =
      searchParameterAvailability.enforceAvailabilityForParameters(
        stateUpdates.availableSearchParameters,
        stateUpdates.searchParameters
      );
    stateUpdates.searchParameters = enforcedSearchParameters;
  }
}
